import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  CookiePolicyDocument,
  CookiePolicyQuery,
  CookiePolicyQueryVariables,
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  HomeSeoDocument,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: FooterDocument });
  await client.query({ query: CookiePolicyDocument });

  const { data: seoData } = await client.query({ query: HomeSeoDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  const { data: cookiePolicy } = await client.query<
    CookiePolicyQuery,
    CookiePolicyQueryVariables
  >({
    query: CookiePolicyDocument,
  });
  return addApolloState(client, {
    props: {
      cookiePolicy,
      footerData,
      headerData,
    },
  });
};

const CookiePolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, cookiePolicy }) => (
  <Layout footerData={footerData} headerData={headerData} invertedColor>
    <Seo seo={cookiePolicy?.cookiePolicy.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={cookiePolicy?.cookiePolicy.data?.attributes?.cookiePolicy}
    />
  </Layout>
);

export default CookiePolicy;
